export const API = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:4200/api';

export const EmailAddress = 'me@ecdevstudio.ca';

export const MOBILE_BREAKPOINT = 769;